import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-view-users-modal',
  templateUrl: './view-users-modal.component.html',
  styleUrls: ['./view-users-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ViewUsersModalComponent {

}
